import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { CropperComponent } from 'angular-cropperjs';
import { OverlayService } from '../../../services/overlay.service';
import { ImagesService } from '../../images.service';

@Component({
    selector: 'app-image-cropper',
    templateUrl: './image-cropper.component.html',
    styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent implements OnInit {
    @Input() image;
    @Output() result: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('angularCropper', { static: false }) public angularCropper: CropperComponent;

    imageChangedEvent: any = '';
    croppedImage: any = '';
    imageToCrop: any = '';
    cropperReady = false;
    ratio = 1;
    config = {
        aspectRatio: '16 / 9',

    };


    constructor(
        private overlayService: OverlayService,
        private imageService: ImagesService,
    ) {

    }

    ngOnInit() {
        this.imageToCrop = this.image.URL;
        // this.angularCropper.cropper.zoom(0.1);
    }

    doReady() {
        this.cropperReady = true;
        this.angularCropper.cropper.setAspectRatio(16 / 6);
        this.croppedImage = this.angularCropper.cropper.getCroppedCanvas().toDataURL();
        this.angularCropper.imageElement.addEventListener('cropend', (event) => {
            this.crop();
        });
    }

    rotate() {
        this.angularCropper.cropper.clear();
        this.angularCropper.cropper.rotate(90);
        this.angularCropper.cropper.setAspectRatio(16 / 6);
        this.crop();
    }

    reset() {
        this.angularCropper.cropper.reset();
        this.crop();
    }

    setRatio(ratio) {
        this.angularCropper.cropper.setAspectRatio(ratio);
        this.crop();
    }

    zoomIn() {
        this.ratio -= 0.1;
        this.angularCropper.cropper.zoom(0.1);
    }

    zoomOut() {
        this.ratio += 0.1;
        this.angularCropper.cropper.zoom(-0.1);
    }

    fullSize() {
        this.angularCropper.cropper.zoomTo(1);
    }

    crop() {
        this.croppedImage = this.angularCropper.cropper.getCroppedCanvas().toDataURL();
    }

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }

    imageCropped(event) {
        this.croppedImage = event.base64;
    }

    imageLoaded() {
        this.cropperReady = true;
        // show cropper
    }

    loadImageFailed() {
        // show message
    }

    save() {
        this.image.imgBase = this.croppedImage;
        this.imageService.crop(this.image).subscribe(data => {
            this.result.emit(this.image);
            this.close();
        });
    }

    close() {
        this.overlayService.close('imageCropper');
    }
}
